import React, { useState, useEffect, useContext } from "react";
import "../css/layout.css";
import "../css/homepage.css";
import css from "../css/with.css";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import "../css/Loader.css";
// import findGif from "../css/loading.gif";
import findGif from "../css/loading_old.gif";
import io from "../Components/socket";
import Header from "../Components/Header";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaUpload, FaUser } from "react-icons/fa";
// import imageCompression from 'browser-image-compression';
import {
  FaUniversity,
  FaShieldAlt,
  FaCode,
} from "react-icons/fa";
const Withdrawopt = ({ walletUpdate }) => {
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const history = useHistory();

  const access_token = localStorage.getItem("token");
  const [Id, setId] = useState(null);
  const [user, setUser] = useState();
  const [holder_name, setHolder_name] = useState();
  const [bank_name, setBank_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [confirm_account_number, setConfirm_account_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [confirm_upi_id, setConfirm_upi_id] = useState();
  const [next, setNext] = useState(false);
  const [paytmNumber, setpaytmNumber] = useState();

  const [isCashFreePayoutActive, setCashFreePayoutActive] = useState(false);
  const [isRazorPayPayoutActive, setRazorPayPayoutActive] = useState(false);
  const [isDecentroPayoutActive, setDecentroPayoutActive] = useState(false);

  const [isRazorPayPayoutAuto, setRazorPayPayoutAuto] = useState(false);
  const [isDecentroPayoutAuto, setDecentroPayoutAuto] = useState(false);
  const [maxAutopayAmt, setMaxAutopayAmt] = useState(0);

  const [submitBtn, setSubmitBtn] = useState(true);
  const [withdrawal, setWithdrawal] = useState(true);
  const [Upiwithdrawal, setUpiWithdrawal] = useState(true);
  const [Bankwithdrawal, setBankWithdrawal] = useState(true);
  const [paytmwithdrawal, setpaytmWithdrawal] = useState(true);
  const [withdrawAmount, setWithdrawAmount] = useState();

  const [minLimit, setMinLimit] = useState(null);
  const [maxLimit, setMaxLimit] = useState(null);
  const [isLoading, setIsloading] = useState(false);

  const [type, setType] = useState(undefined);
  const [mount, setMount] = useState(false);
  const [withdraw_Qr, setwithdraw_Qr] = useState(null);

  useEffect(() => {
    const addsetting = localStorage.getItem("sitSetting");
    const addCaseSetting = JSON.parse(addsetting);
    setWithdrawal(addCaseSetting.isWithdrawal);
    setUpiWithdrawal(addCaseSetting.isUpiWithdrawal);
    setBankWithdrawal(addCaseSetting.isBankWithdrawal);
    setMinLimit(addCaseSetting.withdrawalLimitMin);
    setMaxLimit(addCaseSetting.withdrawalLimitMax);
  });
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const meeApi = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    // axios
    //   .get(baseUrl+`me`, { headers })

    const res = await apiRequest(`me`, "GET", null, headers);
    // .then(res => {
    setUser(res.data);
    // console.log(res.data);
    setId(res.data._id);
    setHolder_name(res.data.holder_name);
    setBank_name(res.data.bank_name);
    setAccount_number(res.data.account_number);
    setConfirm_account_number(res.data.confirm_account_number);
    setIfsc_code(res.data.ifsc_code);
    setUpi_id(res.data.upi_id);
    setConfirm_upi_id(res.data.upi_id);
    // })
    // .catch(e => {
    //   if (e.response.status == 401) {
    //     localStorage.removeItem('token')
    //     localStorage.removeItem('token')
    //     window.location.reload()
    //     history.push('/login')
    //   }
    // })

    // axios
    //   .get(baseUrl+`website/setting`)

    const response = await apiRequest(`website/setting`, "GET", null);
    // .then(res => {
    //console.log(res);
    setCashFreePayoutActive(response.data.isCashFreePayoutActive);
    setRazorPayPayoutActive(true);
    setDecentroPayoutActive(response.data.isDecentroPayoutActive);

    setRazorPayPayoutAuto(response.data.isRazorPayPayoutAuto);
    setDecentroPayoutAuto(response.data.isDecentroPayoutAuto);
    setMaxAutopayAmt(response.data.maxAutopayAmt);
    setpaytmWithdrawal(response.data?.ispaytmWithdrawal);

    // setUpiWithdrawal(addCaseSetting.isUpiWithdrawal)
    // setBankWithdrawal(addCaseSetting.isBankWithdrawal)
    // })
    // .catch(e => {
    //   setCashFreePayoutActive(false)
    //   setRazorPayPayoutActive(false)
    //   setDecentroPayoutActive(false)
    //   setMaxAutopayAmt(0)
    // })
  };

  useEffect(() => {
    meeApi();
  }, []);

  // const handleImageChange = async (e) => {
  //   const file = e.target.files[0];

  //   if (file) {
  //     const options = {
  //       maxSizeMB: 0.6,             // (Max size in MB)
  //       maxWidthOrHeight: 1024,   // (Max dimension - width or height)
  //       useWebWorker: true,
  //     };

  //     try {
  //       const compressedFile = await imageCompression(file, options);
  //       setwithdraw_Qr(compressedFile);
  //     } catch (error) {
  //       console.error('Image compression error:', error);
  //     }
  //   }
  // };

  // const handlePayment = () => {
  //   if (withdrawAmount) {
  //     if (withdrawAmount < minLimit || withdrawAmount > maxLimit) {
  //       Swal.fire({
  //         title: "Invalid amount",
  //         text: ` Minimum withdrawal amount ${minLimit} Maximum withdrawal amount ${maxLimit}`,
  //         icon: "error",
  //         confirmButtonText: "OK",
  //       });
  //     } else {
  //       setNext(2);
  //     }
  //   } else {
  //     Swal.fire({
  //       title: "Please Fill Amount",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //   }
  // };

  const handlePayment = () => {
    if (withdrawAmount) {
      const amount = Number(withdrawAmount);

      // 50 ke multiple check
      if (amount % 50 !== 0) {
        Swal.fire({
          title: "Invalid Amount",
          text: "Please enter amount in multiples of 50 (100, 150, 200...)",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      // Min Max check
      if (amount < minLimit || amount > maxLimit) {
        Swal.fire({
          title: "Invalid Amount",
          text: `Minimum withdrawal amount ${minLimit} and Maximum withdrawal amount ${maxLimit}`,
          icon: "error",
          confirmButtonText: "OK",
        });
      } else {
        setNext(2);
      }
    } else {
      Swal.fire({
        title: "Please Fill Amount",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleIfscChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue.length <= 11) {
      setIfsc_code(inputValue);
    }
  };

  const updateBankDetails = async () => {
    setIsloading(true);

    setMount(true);
    setSubmitBtn(false);
    // e.preventDefault();

    if (type === "upi") {
      let regex = /^[\w.-]+@[\w.-]+$/.test(upi_id);

      if (regex) {
        if (upi_id === confirm_upi_id) {
          Swal.fire({
            title: `Is your UPI ID correct? ${upi_id}`,
            icon: "success",
            confirmButtonText: "OK",
          });

          const access_token = localStorage.getItem("token");
          const headers = {
            Authorization: `Bearer ${access_token}`,
          };
          setIsloading(true);

          let alldata = {
            holder_name,
            upi_id,
          };
          const res = await apiRequest(
            `user/withdraw/edit`,
            "PATCH",
            alldata,
            headers,
          );
          setIsloading(false);
          if (res?.data?.status === true) {
            // console.log(res.data)
            let calculatedWallet =
              user.wonAmount -
              user.loseAmount +
              user.totalDeposit +
              user.referral_earning +
              user.hold_balance +
              user.totalBonus -
              (user.totalWithdrawl + user.referral_wallet + user.totalPenalty);

            calculatedWallet == user.Wallet_balance
              ? doAutoPayout()
              : withReqComes();
          } else {
            setMount(false);
            setSubmitBtn(true);
            Swal.fire({
              title: res.data.msg,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } else {
          Swal.fire({
            title: "UPI IDs do not match",
            text: "Please make sure your UPI IDs match",
            icon: "error",
            confirmButtonText: "OK",
          });

          setSubmitBtn(true);
        }
      } else {
        Swal.fire({
          title: `Invalid UPI ID: ${upi_id}`,
          text: "Please enter a valid UPI ID",
          icon: "error",
          confirmButtonText: "OK",
        });
        setSubmitBtn(true);
      }
    } else if (type === "qrcode" && !withdraw_Qr) {
      Swal.fire({
        title: "QR Code Required",
        text: "Please provide a valid QR Code for withdrawal.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setMount(false);
    } else if (type === "banktransfer") {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      setIsloading(true);
      let alldata = {
        holder_name,
        account_number,
        confirm_account_number,
        ifsc_code,
      };
      const res = await apiRequest(
        `user/withdraw/edit`,
        "PATCH",
        alldata,
        headers,
      );

      setIsloading(false);

      if (res?.data?.status === true) {
        let calculatedWallet =
          user.wonAmount -
          user.loseAmount +
          user.totalDeposit +
          user.referral_earning +
          user.hold_balance +
          user.totalBonus -
          (user.totalWithdrawl + user.referral_wallet + user.totalPenalty);

        calculatedWallet == user.Wallet_balance
          ? doAutoPayout()
          : withReqComes();
      } else {
        setMount(false);
        setSubmitBtn(true);
        Swal.fire({
          title: res.data.msg,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } else if (type === "qrcode") {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };
      const formData = new FormData();

      formData.append("amount", withdrawAmount);
      formData.append("type", type);
      formData.append("payment_gateway", "");
      formData.append("withdraw_Qr", withdraw_Qr);
      formData.append("emergencyWithdraw", "false");

      try {
        const res = await apiRequest(
          "withdraw/request",
          "POST",
          formData,
          headers,
        );

        if (res.data.success) {
          setMount(false);
          Swal.fire({
            title: res?.data?.msg,
            icon: "success",
            confirmButtonText: "OK",
          });
          history.push("/");
        } else {
          // 🔴 Fallback if above block is not active
          Swal.fire({
            title: res.data.msg,
            icon: "error",
            confirmButtonText: "OK",
          });
        }

        setMount(false);
      } catch (e) {
        console.log(e);
        setMount(false);
      }
    } else {
      setMount(false);
      setSubmitBtn(true);
    }
  };

  const [amount, setAmount] = useState();

  //this function for handleAuto payout service with payment gateway

  const doAutoPayout = () => {
    console.log(
      "type",
      type,
      isRazorPayPayoutAuto,
      isDecentroPayoutAuto,
      isCashFreePayoutActive,
    );
    if (isRazorPayPayoutAuto && type == "upi") {
      //alert('payoutFromRazorpay');
      if (amount <= maxAutopayAmt) {
        payoutFromRazorpay();
      } else {
        withReqComes();
      }
    } else if (isDecentroPayoutAuto && type == "banktransfer") {
      //alert('payoutFromDecentro');
      if (amount <= maxAutopayAmt) {
        payoutFromDecentro();
      } else {
        withReqComes();
      }
    } else {
      withReqComes();
    }
  };

  // const payoutFromCashfree = () => {
  //   if (amount && amount >= 95 && amount <= 50000 && type) {
  //     // e.preventDefault();
  //     const payment_gatway = "cashfree";
  //     const access_token = localStorage.getItem("token");
  //     const headers = {
  //       Authorization: `Bearer ${access_token}`,
  //     };

  //     axios
  //       .post(
  //         baseUrl+`withdraw/payoutcashfreebank`,
  //         {
  //           amount,
  //           type,
  //           payment_gatway,
  //         },
  //         { headers }
  //       )
  //       .then((res) => {
  //         walletUpdate();
  //         setMount(false);
  //         console.log(res.data);
  //         if (res.data.subCode === "200") {
  //           console.log("cash res", res);
  //           Swal.fire({
  //             title: res.data.message,
  //             icon: "success",
  //             confirmButtonText: "OK",
  //           });
  //         } else {
  //           Swal.fire({
  //             title: res.data.message,
  //             icon: "danger",
  //             confirmButtonText: "OK",
  //           });
  //         }
  //       })
  //       .catch((e) => {
  //         setMount(false);
  //         Swal.fire({
  //           title: "Error! try after sometime.",
  //           icon: "error",
  //           confirmButtonText: "OK",
  //         });
  //         console.log(e);
  //       });
  //   } else {
  //     setMount(false);
  //     let msg = "Enter all fields";
  //     if (!amount || !type) {
  //       let msg = "Enter all fields";
  //     } else if (95 <= amount <= 50000) {
  //       msg = "amount should be more than 95 and less then 50000.";
  //     }
  //     Swal.fire({
  //       title: msg,
  //       icon: "Error",
  //       confirmButtonText: "OK",
  //     });
  //   }
  // };
  const payoutFromRazorpay = async () => {
    if (amount && amount >= 95 && amount <= 50000 && type) {
      // e.preventDefault();
      const payment_gatway = "";
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      // axios
      //   .post(
      //     baseUrl+`withdraw/payoutrazorpaybank`,
      //     {
      //       amount,
      //       type,
      //       payment_gatway
      //     },
      //     { headers }
      //   )

      const res = await apiRequest(
        `withdraw/payoutrazorpaybank`,
        "POST",
        { amount, type, payment_gatway },
        headers,
      );
      // .then(res => {
      walletUpdate();
      setMount(false);
      console.log(res.data);
      if (res.data.subCode === "200") {
        console.log("cash res", res);
        Swal.fire({
          title: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: res.data.message,
          icon: "danger",
          confirmButtonText: "OK",
        });
      }

      // })
      // .catch(e => {
      //   setMount(false)
      //   Swal.fire({
      //     title: 'Error! try after sometime.',
      //     icon: 'error',
      //     confirmButtonText: 'OK'
      //   })
      //   console.log(e)
      // })
    } else {
      setMount(false);
      let msg = "Enter all fields";
      if (!amount || !type) {
        let msg = "Enter all fields";
      } else if (95 <= amount <= 50000) {
        msg = "amount should be more than 95 and less then 50000.";
      }
      Swal.fire({
        title: msg,
        icon: "Error",
        confirmButtonText: "OK",
      });
    }
  };

  //use for Razorpay payout end

  //use for decentro payout

  const payoutFromDecentro = async () => {
    if (amount && amount >= 95 && amount <= 50000 && type) {
      // e.preventDefault();
      const payment_gatway = "";
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      // axios
      //   .post(
      //     baseUrl+`withdraw/payoutdecentrobank`,
      //     {
      //       amount,
      //       type,
      //       payment_gatway
      //     },
      //     { headers }
      //   )
      const res = await apiRequest(
        `withdraw/payoutdecentrobank`,
        "POST",
        { amount, type, payment_gatway },
        headers,
      );
      // .then(res => {
      setTimeout(() => {
        walletUpdate();
      }, 5000);
      setMount(false);
      console.log(res.data);
      if (res.data.subCode === "200") {
        console.log("cash res", res);
        Swal.fire({
          title: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: res.data.message,
          icon: "danger",
          confirmButtonText: "OK",
        });
      }
      // })
      // .catch(e => {
      //   setMount(false)
      //   Swal.fire({
      //     title: 'Error! try after sometime.',
      //     icon: 'error',
      //     confirmButtonText: 'OK'
      //   })
      //   console.log(e)
      // })
    } else {
      setMount(false);
      let msg = "Enter all fields";
      if (!amount || !type) {
        let msg = "Enter all fields";
      } else if (95 <= amount <= 50000) {
        msg = "amount should be more than 95 and less then 50000.";
      }
      Swal.fire({
        title: msg,
        icon: "Error",
        confirmButtonText: "OK",
      });
    }
  };

  //use for decentro payout end

  const handleSubmitdata = async () => {
    if (amount && amount >= 95 && amount <= 20000 && type) {
      // e.preventDefault();
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      // axios
      //   .post(
      //     baseUrl+`withdraw/bank`,
      //     {
      //       amount,
      //       type
      //     },
      //     { headers }
      //   )

      const res = await apiRequest(
        `withdraw/bank`,
        "POST",
        { amount, type },
        headers,
      );
      // .then(res => {
      setTimeout(() => {
        walletUpdate();
      }, 5000);
      setMount(false);
      console.log(res.data);
      if (res.data.subCode === "200") {
        console.log("cash res", res);
        Swal.fire({
          title: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: res.data.message,
          icon: "danger",
          confirmButtonText: "OK",
        });
      }
      // })
      // .catch(e => {
      //   setMount(false)
      //   Swal.fire({
      //     title: 'Error! try after sometime.',
      //     icon: 'error',
      //     confirmButtonText: 'OK'
      //   })
      //   console.log(e)
      // })
    } else {
      setMount(false);
      let msg = "Enter all fields";
      if (!amount || !type) {
        let msg = "Enter all fields";
      } else if (95 <= amount <= 20000) {
        msg = "amount should be more than 95 and less then 100000.";
      }
      Swal.fire({
        title: msg,
        icon: "Error",
        confirmButtonText: "OK",
      });
    }
  };

  const withReqComes = async () => {
    try {
      setMount(true);

      if (type == "upi") {
        var payment_gatway = "";
      } else {
        var payment_gatway = "";
      }

      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      if (amount < minLimit || amount > maxLimit) {
        Swal.fire({
          title: "Invalid amount",
          text: "Please enter an amount within the allowed limits.",
          icon: "error",
          confirmButtonText: "OK",
        });
      } else {
        setMount(true);
        let alldata = {
          holder_name,
          type,
          account_number,
          confirm_account_number,
          ifsc_code,
          upi_id,
          bankDetails: true,
          amount,
          payment_gatway,
        };
        const res = await apiRequest(
          `withdraw/request`,
          "POST",
          alldata,
          headers,
        );
        // .then(res => {
        if (res.data.success) {
          setMount(false);

          Swal.fire({
            title: res?.data?.msg,
            icon: "success",
            confirmButtonText: "OK",
          });
          history.push("/");
        } else {
          Swal.fire({
            title: res.data.msg,
            icon: "error",
            confirmButtonText: "OK",
          });
        }

        setMount(false);
        // })
        // .catch(e => {
        //   console.log(e)
        //   setMount(false)
        // })
      }
    } catch (error) {
      console.log(error);
    }
  };

  // language
  const translations = {
    hi: {
      kyc: "निकासी के लिए केवाईसी पूरा करें यहां क्लिक करें |",
    },
    en: {
      kyc: "Complete KYC to take Withdrawals Click here",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme = localStorage.getItem("theme");

  const styles = {
    backgroundColor: theme === "light" ? "#d3e3fd" : "black",
    color: theme === "light" ? "black" : "#fff",
    // padding: '20px',
    // margin: '20px',
  };

  const styles3 = {
    backgroundColor: theme === "light" ? "#facc06" : "#27241b",
    color: theme === "light" ? "black" : "#fff",
  };

  return (
    <>
      <div
        className="withdrawal_page_main"

      >
        <div className="">
          <div className="row">
            <div className="col mx-auto">
              <div className="mt-3">
                {user &&
                  user?.verified === "verified" &&
                  user?.Email !== null && (
                    <div className=" ">
                      {/* <h4 className='pt-1 profile_headings text-center animated-text   ' style={styles}>
                      {type == undefined
                        ? 'Choose withdrawal option'
                        : 'Withdraw through'}
                    </h4> */}

                      <div className="">
                        { }
                        <div className="alrt_msg_div" style={styles3}>
                          <h5 className="">
                            {JSON.parse(localStorage.getItem("sitSetting")) ==
                              "undefined"
                              ? ""
                              : JSON.parse(localStorage.getItem("sitSetting"))
                                ?.withdraw_message}
                          </h5>
                        </div>
                      </div>

                      {Boolean(!next) && (
                        <>
                          <div className="withdraw_premium_card">

                            <div className="withdraw_header">
                              <span className="withdraw_title">
                                Withdraw Amount
                              </span>
                            </div>

                            <div className="withdraw_amount_box">

                              <div className="withdraw_rupee_circle">
                                <img
                                  src="/images/rupee.png"
                                  alt=""
                                  className="withdraw_rupee_img"
                                />
                              </div>

                              <div className="withdraw_input_wrapper">

                                <span className="withdraw_hint">
                                  Enter Amount
                                </span>

                                <input
                                  className="withdraw_premium_input"
                                  type="tel"
                                  id="amountInput"
                                  placeholder="0"
                                  onChange={(e) =>
                                    setWithdrawAmount(e.target.value)
                                  }
                                />

                              </div>

                            </div>

                            <button
                              type="button"
                              className="withdraw_next_btn"
                              onClick={handlePayment}
                            >
                              Continue Withdrawal
                            </button>

                          </div>
                        </>
                      )}

                      {next === 2 ? (
                        <div>
                          {/* upi id */}
                          {Upiwithdrawal === true
                            ? Boolean(isRazorPayPayoutActive) && (
                              <div
                                className="mlk_qr_withdrawal_card my-3"
                                onClick={() => {
                                  setType("upi");
                                  // setNext(true);
                                  setNext(3);

                                }}
                              >

                                <div className="mlk_qr_glow"></div>

                                <div className="mlk_qr_left">

                                  <div className="mlk_qr_icon_box">
                                    <img
                                      src={process.env.PUBLIC_URL + "/UPI.png"}
                                      alt="UPI"
                                    />
                                  </div>

                                </div>

                                <div className="mlk_qr_right">

                                  <div className="mlk_qr_header">

                                    <h3 className="mlk_qr_title">
                                      UPI
                                    </h3>

                                    <div className="mlk_qr_badge">
                                      INSTANT
                                    </div>

                                  </div>

                                  <ul className="mlk_qr_list">

                                    <li>
                                      Minimum withdrawal amount
                                      <span>{minLimit}</span>
                                    </li>

                                    <li>
                                      Maximum withdrawal amount
                                      <span>{maxLimit}</span>
                                    </li>

                                    <li>
                                      Instant withdrawal within 30 sec
                                    </li>

                                  </ul>

                                </div>

                                <div className="mlk_qr_arrow">
                                  ›
                                </div>

                              </div>
                            )
                            : ""}
                          {/* bank account number */}
                          {withdrawAmount >=
                            addCaseSetting?.withdrawalLimitMinBank &&
                            Bankwithdrawal === true &&
                            withdrawAmount <=
                            addCaseSetting?.withdrawalLimitMaxBank
                            ? Boolean(isRazorPayPayoutActive) && (
                              <div
                                className="mlk_qr_withdrawal_card mlk_bank_card my-3"
                                onClick={() => {
                                  setType("banktransfer");
                                  setNext(3);
                                }}
                              >
                                <div className="mlk_qr_glow"></div>

                                <div className="mlk_qr_left">
                                  <div className="mlk_qr_icon_box">
                                    <img
                                      src="../images/icons/bank.gif"
                                      alt="Bank Transfer"
                                    />
                                  </div>
                                </div>

                                <div className="mlk_qr_right">
                                  <div className="mlk_qr_header">
                                    <h3 className="mlk_qr_title">
                                      BANK TRANSFER
                                    </h3>

                                    <div className="mlk_qr_badge">
                                      SECURE
                                    </div>
                                  </div>

                                  <ul className="mlk_qr_list">
                                    <li>
                                      Minimum withdrawal amount
                                      <span>{minLimit}</span>
                                    </li>

                                    <li>
                                      Maximum withdrawal amount
                                      <span>{maxLimit}</span>
                                    </li>

                                    <li>
                                      Instant withdrawal within 30 sec
                                    </li>
                                  </ul>
                                </div>

                                <div className="mlk_qr_arrow">
                                  ›
                                </div>
                              </div>
                            )
                            : ""}

                          {/* Qrwithdrawal */}
                          {withdrawAmount >=
                            addCaseSetting?.withdrawalLimitMinQr &&
                            addCaseSetting?.isQrWithdrawal === true &&
                            withdrawAmount <= addCaseSetting?.withdrawalLimitMaxQr
                            ? Boolean(isRazorPayPayoutActive) && (
                              <div
                                className="mlk_qr_withdrawal_card my-3"
                                onClick={() => {
                                  setType("qrcode");
                                  setNext(3);
                                }}
                              >

                                <div className="mlk_qr_glow"></div>

                                <div className="mlk_qr_left">

                                  <div className="mlk_qr_icon_box">
                                    <img
                                      src="https://cdn-icons-png.flaticon.com/128/12996/12996071.png"
                                      alt=""
                                    />
                                  </div>

                                </div>

                                <div className="mlk_qr_right">

                                  <div className="mlk_qr_header">

                                    <h3 className="mlk_qr_title">
                                      QR CODE
                                    </h3>

                                    <div className="mlk_qr_badge">
                                      INSTANT
                                    </div>

                                  </div>

                                  <ul className="mlk_qr_list">

                                    <li>
                                      Minimum withdrawal amount
                                      <span>{minLimit}</span>
                                    </li>

                                    <li>
                                      Maximum withdrawal amount
                                      <span>{maxLimit}</span>
                                    </li>

                                    <li>
                                      Instant withdrawal within 30 sec
                                    </li>

                                  </ul>

                                </div>

                                <div className="mlk_qr_arrow">
                                  ›
                                </div>

                              </div>
                            )
                            : ""}

                          {/* paytm number */}
                          {paytmwithdrawal === true
                            ? Boolean(isRazorPayPayoutActive) && (
                              <div
                                onClick={() => {
                                  setType("paytmransfer");
                                  setNext(true);
                                }}
                                className="add-fund-box my-3"
                              // style={{ paddingTop: '0px', height: '60px' }}
                              >
                                <div
                                  className="d-flex align-items-center profile_info_small_box_main bank_page_cards"
                                  style={{ minHeight: "auto" }}
                                >
                                  <div
                                    className="d-flex align-items-center"
                                  // style={{
                                  //   height: '60px',
                                  //   display: 'flex',
                                  //   textAlign: 'center'
                                  // }}
                                  >
                                    <img
                                      width="45px"
                                      src="../images/icons/bank.gif"
                                      alt=""
                                      style={{
                                        marginLeft: "7px",
                                        paddingBottom: "10px",
                                        paddingLeft: "3px",
                                        paddingTop: "5px",
                                      }}
                                    />
                                  </div>
                                  <div className="d-flex justify-content-center flex-column ml-4">
                                    <div className="text-left">
                                      <h3 style={{ fontWeight: "500" }}>
                                        Paytm Transfer
                                      </h3>
                                      <ul>
                                        <li>
                                          Minimum withdrawal amount {minLimit}
                                        </li>
                                        <li>
                                          Instant withdrawal within 30sec.
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="jss31"></div>
                                  </div>
                                </div>
                              </div>
                            )
                            : ""}
                        </div>
                      ) : (
                        ""
                      )}

                      {Boolean(next) && (
                        <div>
                          <div className="row p-1" style={{ background: "#080021" }}>
                            <div className="text-left w-100">
                              {/*   Edit  */}

                              {/* upi id */}
                              {Boolean(
                                isRazorPayPayoutActive ||
                                isCashFreePayoutActive,
                              ) &&
                                Boolean(type == "upi") && (
                                  <div className="add-fund-box mt-3">
                                    <div className="mlk_qr_withdrawal_card mlk_upi_card">

                                      <div className="mlk_qr_glow"></div>

                                      <div className="mlk_qr_left">
                                        <div className="mlk_qr_icon_box">
                                          <img
                                            src={process.env.PUBLIC_URL + "/UPI.png"}
                                            alt="UPI"
                                          />
                                        </div>
                                      </div>

                                      <div className="mlk_qr_right">

                                        <div className="mlk_qr_header">

                                          <h3 className="mlk_qr_title">
                                            Withdraw through UPI
                                          </h3>

                                          <div className="mlk_qr_badge">
                                            ACTIVE
                                          </div>

                                        </div>

                                        <ul className="mlk_qr_list">

                                          <li>
                                            Minimum withdrawal amount
                                            <span>{minLimit}</span>
                                          </li>

                                          <li>
                                            Instant withdrawal within 30 sec
                                          </li>

                                        </ul>

                                      </div>

                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setNext(false);
                                        }}
                                        className="mlk_edit_btn"
                                      >
                                        Edit
                                      </button>

                                    </div>
                                  </div>
                                )}
                              {/* bank account number */}
                              {Boolean(isRazorPayPayoutActive) &&
                                Boolean(type == "banktransfer") && (
                                  <div className="mlk_bank_transfer_card my-3">

                                    <div className="mlk_bank_glow"></div>

                                    <div className="mlk_bank_left">

                                      <div className="mlk_bank_icon_box">

                                        <img
                                          src="../images/icons/bank.gif"
                                          alt=""
                                        />

                                      </div>

                                    </div>

                                    <div className="mlk_bank_content">

                                      <div className="mlk_bank_header">

                                        <h3 className="mlk_bank_title">
                                          Bank Transferss
                                        </h3>

                                        <div className="mlk_bank_badge">
                                          FAST
                                        </div>

                                      </div>

                                      <ul className="mlk_bank_list">

                                        <li>
                                          Minimum withdrawal amount
                                          <span>{minLimit}</span>
                                        </li>

                                        <li>
                                          Instant withdrawal within 30 sec
                                        </li>

                                      </ul>

                                    </div>

                                    <button
                                      onClick={() => {
                                        setType(undefined);
                                        setNext(false);
                                        console.log(type);
                                      }}
                                      className="mlk_bank_edit_btn"
                                    >
                                      Edit
                                    </button>

                                  </div>
                                )}

                              {/* paytm number */}
                              {Boolean(isRazorPayPayoutActive) &&
                                Boolean(type == "paytmransfer") && (
                                  <div className="add-fund-box my-3 ">
                                    <div
                                      className="d-flex align-items-center profile_info_small_box_main bank_page_cards"
                                      style={{ minHeight: "auto" }}
                                    >
                                      <div className="d-flex align-items-center">
                                        <img
                                          width="45px"
                                          src="../images/icons/bank.gif"
                                          alt=""
                                          style={{
                                            marginLeft: "7px",
                                            paddingBottom: "10px",
                                            paddingLeft: "3px",
                                            paddingTop: "5px",
                                          }}
                                        />
                                      </div>
                                      <div className="d-flex justify-content-center flex-column ml-4">
                                        <div className="text-left">
                                          <h3 style={{ fontWeight: "500" }}>
                                            Paytm Transfer
                                          </h3>

                                          <ul>
                                            <li>
                                              Minimum withdrawal amount{" "}
                                              {minLimit}
                                            </li>
                                            <li>
                                              Instant withdrawal within 30sec.
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="jss31"></div>
                                      </div>
                                      <button
                                        onClick={() => {
                                          setType(undefined);
                                          setNext(false);
                                          console.log(type);
                                        }}
                                        className="btn btn-info text-white font-weight-bold ml-auto mr-3"
                                        style={{ fontSize: "0.5rem" }}
                                      >
                                        Edit
                                      </button>
                                    </div>
                                  </div>
                                )}

                              <div className="mt-3">
                                {/* bank account number */}
                                {Boolean(isRazorPayPayoutActive) &&
                                  type == "banktransfer" && (
                                    <div className="mlk_form_card mt-3">

                                      <h4 className="mlk_form_title">
                                        Bank Account Details
                                      </h4>

                                      <div className="mlk_form_group">
                                        <label className="mlk_form_label">
                                          <FaUser />
                                          Account Holder Name
                                        </label>

                                        <input
                                          type="text"
                                          className="mlk_form_input"
                                          placeholder="Enter Account Holder Name"
                                          value={holder_name}
                                          onChange={(e) => setHolder_name(e.target.value)}
                                          required
                                        />
                                      </div>

                                      <div className="mlk_form_group">
                                        <label className="mlk_form_label">
                                          <FaUniversity />
                                          Account Number
                                        </label>

                                        <input
                                          type="number"
                                          className="mlk_form_input"
                                          placeholder="Enter Account Number"
                                          value={account_number}
                                          onChange={(e) => setAccount_number(e.target.value)}
                                        />
                                      </div>

                                      <div className="mlk_form_group">
                                        <label className="mlk_form_label">
                                          <FaShieldAlt />
                                          Confirm Account Number
                                        </label>

                                        <input
                                          type="number"
                                          className="mlk_form_input"
                                          placeholder="Re-enter Account Number"
                                          value={confirm_account_number}
                                          onChange={(e) =>
                                            setConfirm_account_number(e.target.value)
                                          }
                                        />
                                      </div>

                                      <div className="mlk_form_group">
                                        <label className="mlk_form_label">
                                          <FaCode />
                                          IFSC Code
                                        </label>

                                        <input
                                          type="text"
                                          className="mlk_form_input"
                                          placeholder="Enter IFSC Code"
                                          value={ifsc_code}
                                          onChange={handleIfscChange}
                                        />
                                      </div>

                                      <div className=" mlk_form_group">

                                        <label className="mlk_form_label">

                                          <img
                                            src="/images/rupee.png"
                                            alt=""
                                            className="mlk_rupee_icon"
                                          />

                                          Amount

                                        </label>

                                        <div className="mt-2">

                                          <input
                                            type="phone"
                                            className="mlk_form_input"
                                            name="amount"
                                            placeholder="Enter withdrawal amount"
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              e.target.value = value.replace(/[^\d]/g, "");
                                              setAmount(e.target.value);
                                            }}
                                          />

                                        </div>

                                      </div>

                                    </div>
                                  )}

                                {type === "qrcode" && (
                                  <div className="mlk_qr_form_card">

                                    <div className="mlk_qr_form_title">
                                      QR Withdrawal Details
                                    </div>

                                    {/* Account Holder Name */}

                                    <div className="mlk_qr_field">

                                      <label className="mlk_qr_label">
                                        <FaUser />

                                        Account Holder Name
                                      </label>

                                      <input
                                        type="text"
                                        className="mlk_qr_input"
                                        placeholder="Enter Account Holder Name"
                                        value={holder_name}
                                        onChange={(e) => setHolder_name(e.target.value)}
                                        required
                                      />

                                    </div>

                                    {/* Upload QR */}

                                    <div className="mlk_qr_field">

                                      <label className="mlk_qr_label">
                                        <FaUpload />

                                        Upload Your QR Code
                                      </label>

                                      <div className="mlk_qr_upload_box">

                                        <input
                                          type="file"
                                          accept="image/*"
                                          className="mlk_qr_file_input"
                                          onChange={(e) =>
                                            setwithdraw_Qr(e.target.files[0])
                                          }
                                        />

                                      </div>

                                    </div>
                                    <div className=" mlk_qr_field">

                                      <label className="mlk_qr_label">

                                        <img
                                          src="/images/rupee.png"
                                          alt=""
                                          className="mlk_rupee_icon"
                                        />

                                        Amount

                                      </label>

                                      <div className="mt-2">

                                        <input
                                          type="phone"
                                          className="mlk_qr_input"
                                          name="amount"
                                          placeholder="Enter withdrawal amount"
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            e.target.value = value.replace(/[^\d]/g, "");
                                            setAmount(e.target.value);
                                          }}
                                        />

                                      </div>

                                    </div>

                                  </div>
                                )}
                                {/* upi id */}
                                {Boolean(isRazorPayPayoutActive) &&
                                  type == "upi" && (
                                    <div className="mlk_form_card mt-3">

                                      <h4 className="mlk_form_title">
                                        UPI Details
                                      </h4>

                                      <div className="mlk_form_group">
                                        <label className="mlk_form_label">
                                          <img src="./images/holder.png" alt="" />
                                          Account Holder Name
                                        </label>

                                        <input
                                          type="text"
                                          className="mlk_form_input"
                                          placeholder="Enter Account Holder Name"
                                          value={holder_name}
                                          onChange={(e) => setHolder_name(e.target.value)}
                                          required
                                        />
                                      </div>

                                      <div className="mlk_form_group">
                                        <label className="mlk_form_label">
                                          <img src="./images/cashless-payment.png" alt="" />
                                          UPI ID
                                        </label>

                                        <input
                                          type="text"
                                          className="mlk_form_input"
                                          placeholder="9999999999@paytm"
                                          value={upi_id}
                                          onChange={(e) => setUpi_id(e.target.value)}
                                        />
                                      </div>

                                      <div className="mlk_form_group">
                                        <label className="mlk_form_label">
                                          <img src="./images/payment-method.png" alt="" />
                                          Confirm UPI ID
                                        </label>

                                        <input
                                          type="text"
                                          className="mlk_form_input"
                                          placeholder="Re-enter UPI ID"
                                          value={confirm_upi_id}
                                          onChange={(e) => setConfirm_upi_id(e.target.value)}
                                        />
                                      </div>

                                      <div className=" mlk_form_group">

                                        <label className="mlk_form_label">

                                          <img
                                            src="/images/rupee.png"
                                            alt=""
                                            className="mlk_rupee_icon"
                                          />

                                          Amount

                                        </label>

                                        <div className="mt-2">

                                          <input
                                            type="phone"
                                            className="mlk_form_input"
                                            name="amount"
                                            placeholder="Enter withdrawal amount"
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              e.target.value = value.replace(/[^\d]/g, "");
                                              setAmount(e.target.value);
                                            }}
                                          />

                                        </div>

                                      </div>

                                    </div>
                                  )}

                                {/* paytm number */}
                                {Boolean(isRazorPayPayoutActive) &&
                                  type == "paytmransfer" && (
                                    <div>
                                      <div>
                                        <label
                                          htmlFor="username "
                                          className=" commaon_label"
                                          style={{ color: "green" }}
                                        >
                                          <FaUser />
                                          Account holder name (खाता धारक का नाम)
                                        </label>
                                        <div className="col-12 mb-3 p-0">
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="account_no"
                                            placeholder="Enter Account Name"
                                            name="ifsc"
                                            value={holder_name}
                                            onChange={(e) =>
                                              setHolder_name(e.target.value)
                                            }
                                            required
                                          />
                                        </div>
                                      </div>

                                      <div>
                                        <label
                                          htmlFor="username "
                                          className=" commaon_label"
                                          style={{ color: "green" }}
                                        >
                                          <i className="far fa-bank mr-2"></i>
                                          Paytm number (Paytm नंबर):
                                        </label>
                                        <div className="col-12 mb-3 p-0">
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="account_no"
                                            placeholder="Enter your Paytm number"
                                            name="upi"
                                            value={paytmNumber}
                                            onChange={(e) =>
                                              setpaytmNumber(e.target.value)
                                            }
                                          />
                                        </div>
                                        <label
                                          htmlFor="username "
                                          className=" commaon_label"
                                          style={{ color: "green" }}
                                        >
                                          <i className="far fa-bank mr-2"></i>{" "}
                                          Confirm Paytm number (कन्फर्म Paytm
                                          नंबर) :
                                        </label>
                                        <div className="col-12 mb-3 p-0">
                                          <input
                                            type="text"
                                            className="form-control commaon_input_box"
                                            id="account_no"
                                            placeholder="Re Enter Your Paytm Number"
                                            name="ifsc"
                                            value={confirm_account_number}
                                            onChange={(e) =>
                                              setConfirm_account_number(
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                              </div>
                            </div>

                            {/* bank details end */}
                            {next === 3 ? (
                              <>
                                <>

                                  {/* <div className="mlk_withdraw_amount_card mt-3">

                                    <label className="mlk_withdraw_label">

                                      <img
                                        src="/images/rupee.png"
                                        alt=""
                                        className="mlk_rupee_icon"
                                      />

                                      Amount

                                    </label>

                                    <div className="mt-2">

                                      <input
                                        type="phone"
                                        className="mlk_withdraw_input"
                                        name="amount"
                                        placeholder="Enter withdrawal amount"
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          e.target.value = value.replace(/[^\d]/g, "");
                                          setAmount(e.target.value);
                                        }}
                                      />

                                    </div>

                                  </div> */}

                                  <div
                                    className="mt-3 w-100"
                                    style={{ marginBottom: "55px" }}
                                  >

                                    {isLoading ? (

                                      <div className="text-center">

                                        <img
                                          src="/images/LandingPage_img/loader1.gif"
                                          className="mlk_withdraw_loader"
                                        />

                                      </div>

                                    ) : (

                                      <button
                                        type="button"
                                        id="withdrawcase"
                                        className="mlk_withdraw_submit_btn"
                                        disabled={Boolean(submitBtn) ? false : true}
                                        onClick={() => updateBankDetails()}
                                      >
                                        WITHDRAWAL SUBMIT
                                      </button>

                                    )}

                                  </div>

                                </>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                {user && user?.verified === "unverified" && (
                  <Link to="/Profile?kyc=true">
                    <div style={{ height: "100px" }} className="kyc_page_cards kyc_unverified_card">
                      <picture className="ml-3">
                        <img
                          src="/images/alert.svg"
                          alt=""
                          width="32px"
                          className=""
                        />
                      </picture>
                      <p className="ml-1  mytext ">
                        {translations[language].kyc}
                      </p>
                    </div>
                  </Link>
                )}
                {user && user.verified === "reject" && (
                  <div style={{ height: "100px" }} className="kyc_page_cards kyc_rejected_card">
                    <picture className="ml-3">
                      <img
                        src="/images/alert.svg"
                        alt=""
                        width="32px"
                        className=""
                      />
                    </picture>
                    <p className="ml-1  mytext ">
                      Your kyc was rejected please please try again !
                    </p>
                  </div>
                )}
                {user && user.verified === "pending" && (
                  <div style={{ height: "100px" }} className="kyc_page_cards kyc_pending_card">
                    <picture className="ml-3">
                      <img
                        src="/images/alert.svg"
                        alt=""
                        width="32px"
                        className=""
                      />
                    </picture>
                    <p className="ml-1  mytext  ">
                      Please wait your kyc under process
                    </p>
                  </div>
                )}
                {user && user?.Email === null && (
                  <div style={{ height: "100px" }} className="kyc_page_cards kyc_email_card">
                    <picture className="ml-3">
                      <img
                        src="/images/alert.svg"
                        alt=""
                        width="32px"
                        className=""
                      />
                    </picture>
                    <p className="ml-1  mytext ">
                      Complete Email Verification to take Withdrawals
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Withdrawopt;
